import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { AsyncSection } from "../ds";
import { MONO, useTableStyles } from "../tableStyles";
import { evalRuns } from "./api";
import { fmtRate, fmtTime } from "./shared";

const passK = (suite) => {
  const all = suite?.table?.ALL;
  if (!all || all.n == null) return "—";
  return `${fmtRate(all.pass_k)} (${all.passed}/${all.n})`;
};

const errs = (r) =>
  Object.entries(r.suites || {})
    .map(([name, s]) => `${name} ${s.agent_errors || 0}/${s.judge_errors || 0}`)
    .join(" · ") || "—";

const COLUMNS = ["When", "Build", "k", "Synthetic pass^k", "Synthetic critical", "Benchmark", "Golden pass^k", "Guard violations", "Agent/judge errors"];

export default function EvalRunsTab({ refreshKey }) {
  const table = useTableStyles();
  const [state, setState] = useState({ loading: true, notFound: false, error: null, data: null });

  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    evalRuns({ limit: 30 }).then((r) => alive && setState({ ...r, loading: false }));
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  const runs = [...(state.data?.runs || [])].sort((a, b) => String(b.created || "").localeCompare(String(a.created || "")));

  return (
    <AsyncSection loading={state.loading} notFound={state.notFound} error={state.error} empty={!runs.length} emptyTitle="No eval runs recorded">
      <div className={table.tableWrap}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {COLUMNS.map((h) => <TableCell key={h} className={table.headCell}>{h}</TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {runs.map((r) => {
              const syn = r.suites?.synthetic;
              const gold = r.suites?.golden;
              return (
                <TableRow key={r._id || r.run_id}>
                  <TableCell className={table.cell}>{fmtTime(r.created)}</TableCell>
                  <TableCell className={table.cell} style={{ fontFamily: MONO, fontSize: 12 }}>{String(r.build_sha || r.run_id || r._id).slice(0, 10)}</TableCell>
                  <TableCell className={table.cell}>{r.k ?? "—"}</TableCell>
                  <TableCell className={table.cell}>{passK(syn)}</TableCell>
                  <TableCell className={table.cell}>{fmtRate(syn?.table?.ALL?.critical_rate)}</TableCell>
                  <TableCell className={table.cell}>{syn?.mean_benchmark != null ? syn.mean_benchmark.toFixed(3) : "—"}</TableCell>
                  <TableCell className={table.cell}>{passK(gold)}</TableCell>
                  <TableCell className={table.cell}>{gold?.source?.guard_violations ?? "—"}</TableCell>
                  <TableCell className={table.cell}>{errs(r)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </AsyncSection>
  );
}
